import { useSetAnswerLikeMutation } from './mobile/qna.gql.impl';

interface Props {
  onSuccess: () => void;
}
const useSetAnswerLike = ({ onSuccess }: Props) => {
  const { mutate: setAnswerLikeMutate } = useSetAnswerLikeMutation({
    onSuccess,
  });

  return {
    setAnswerLikeMutate,
  };
};

export default useSetAnswerLike;
